export default __webpack_public_path__ + "static/media/Contract.b0323191.svg";